// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/font/Inter-VariableFont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/tablet.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  src: local("Inter"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
.hero-section .row .col {
  z-index: 1;
}
.hero-section .row.row-1 {
  align-items: center;
  position: relative;
  justify-content: center;
  margin: 22px auto;
}
.hero-section .row-1 .col-a {
  justify-content: center;
  align-items: center;
  display: flex;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  padding: 1.9% 1.6% 1.4% 2%;
  background-repeat: no-repeat;
  background-size: 100% 86%;
  overflow: hidden;
  aspect-ratio: 556/364;
  background-position: center;
}
.hero-section .video {
  overflow: hidden;
  border-radius: 10px;
  position: relative;
}
.hero-section .video .pause-icon {
  cursor: pointer;
  position: absolute;
  left: 0%;
  top: 35%;
  width: -webkit-fill-available;
}
.hero-section .video iframe {
  width: 100%;
  height: 75vh;
}
.hero-section .heading {
  font-family: "Inter";
  font-size: 45px;
  font-weight: 900;
  line-height: 46px;
  letter-spacing: 0em;
  color: #EE3A24;
}
.hero-section .col-b {
  text-align: center;
}
.hero-section .col-b .text {
  max-width: 378px;
  width: 100%;
  margin: 2.25rem auto;
}
.hero-section .col-b .button {
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  gap: 8px;
  margin: 0 auto 10px;
  font-weight: 900;
  font-size: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.hero-section .cta-container {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.video-container {
  position: relative;
  max-width: 100%;
  padding: 1.5% 1.8% 1% 1%;
  z-index: 2;
}
.video-container .pause-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.tablet-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%; /* Ensure the tablet frame spans the entire container */
  height: -webkit-fill-available; /* Maintain aspect ratio */
  z-index: 1; /* Ensure the tablet frame is above the video */
}

.video-file {
  width: 100%;
  height: auto; /* Maintain aspect ratio */
  z-index: 0; /* Ensure the video is below the tablet frame */
}

.hero-section .row-1:after,
.hero-section .row-1:before {
  content: "";
  position: absolute;
  width: 316.97px;
  height: 316.97px;
  flex-shrink: 0;
  border-radius: 316.97px;
}

.hero-section .row-1:after {
  background: #ee3a24;
  filter: blur(154.1499938965px);
  top: -25.69px;
  left: -51px;
}

.hero-section .row-1:before {
  background: #9747ff;
  filter: blur(154.1499938965px);
  bottom: -25.69px;
  right: -51px;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

@media (max-width: 1100px) {
  .row {
    flex-direction: column;
  }
  .hero-section .col-7 {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/_fonts.scss","webpack://./src/style/pages/Home.scss","webpack://./src/style/_variables.scss","webpack://./src/style/_colors.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,+EAAA;ACCJ;AACE;EACE,UAAA;AACJ;AACE;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;AACJ;AACE;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,yDAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,2BAAA;AACJ;AACE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAAI;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,6BAAA;AAEN;AACE;EACE,WAAA;EACA,YAAA;AACJ;AACE;EDnCE,oBAAA;ECqCA,eC3CU;ED4CV,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cE/CY;AFgDhB;AACE;EACE,kBAAA;AACJ;AACE;EACE,gBAAA;EACA,WAAA;EACA,oBAAA;AACJ;AACE;EAEE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAAJ;AAEE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAAJ;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,UAAA;AAAF;AAEE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA,EAAA,uDAAA;EACA,8BAAA,EAAA,0BAAA;EACA,UAAA,EAAA,+CAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA,EAAA,0BAAA;EACA,UAAA,EAAA,+CAAA;AADF;;AAIA;;EAEE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AADF;;AAGA;EACE,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;AAAF;;AAEA;EACE,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;AACF;;AACA;EACE,WAAA;EACA,WAAA;EACA,cAAA;AAEF;;AAAA;EACE;IACE,sBAAA;EAGF;EADA;IACE,sBAAA;EAGF;AACF","sourcesContent":["@font-face {\n    font-family: \"Inter\";\n    src: local(\"Inter\"),\n     url(\"../assets/font/Inter-VariableFont.ttf\") format(\"truetype\");\n   }\n@mixin primeFont() {\n    font-family: \"Inter\";\n}","@import \"../mixins\";\n@import \"../colors\";\n\n.hero-section {\n  .row .col {\n    z-index: 1;\n  }\n  .row.row-1 {\n    align-items: center;\n    position: relative;\n    justify-content: center;\n    margin: 22px auto;\n  }\n  .row-1 .col-a {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    background-image: url(\"../../assets/images/tablet.png\");\n    padding: 1.9% 1.6% 1.4% 2%;\n    background-repeat: no-repeat;\n    background-size: 100% 86%;\n    overflow: hidden;\n    aspect-ratio: 556/364;\n    background-position: center;\n  }\n  .video {\n    overflow: hidden;\n    border-radius: 10px;\n    position: relative;\n    .pause-icon {\n      cursor: pointer;\n      position: absolute;\n      left: 0%;\n      top: 35%;\n      width: -webkit-fill-available;\n    }\n  }\n  .video iframe {\n    width: 100%;\n    height: 75vh;\n  }\n  .heading {\n    @include primeFont();\n    font-size: $headingFont;\n    font-weight: 900;\n    line-height: 46px;\n    letter-spacing: 0em;\n    color: $primary-color;\n  }\n  .col-b {\n    text-align: center;\n  }\n  .col-b .text {\n    max-width: 378px;\n    width: 100%;\n    margin: 2.25rem auto;\n  }\n  .col-b .button {\n    @extend .button;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: max-content;\n    gap: 8px;\n    margin: 0 auto 10px;\n    font-weight: 900;\n    font-size: 22px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  .cta-container {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n  }\n}\n.video-container {\n  position: relative;\n  max-width: 100%;\n  padding: 1.5% 1.8% 1% 1%;\n  z-index: 2;\n\n  .pause-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.tablet-frame {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%; /* Ensure the tablet frame spans the entire container */\n  height: -webkit-fill-available; /* Maintain aspect ratio */\n  z-index: 1; /* Ensure the tablet frame is above the video */\n}\n\n.video-file {\n  width: 100%;\n  height: auto; /* Maintain aspect ratio */\n  z-index: 0; /* Ensure the video is below the tablet frame */\n}\n\n.hero-section .row-1:after,\n.hero-section .row-1:before {\n  content: \"\";\n  position: absolute;\n  width: 316.97px;\n  height: 316.97px;\n  flex-shrink: 0;\n  border-radius: 316.97px;\n}\n.hero-section .row-1:after {\n  background: #ee3a24;\n  filter: blur(154.1499938965px);\n  top: -25.69px;\n  left: -51px;\n}\n.hero-section .row-1:before {\n  background: #9747ff;\n  filter: blur(154.1499938965px);\n  bottom: -25.69px;\n  right: -51px;\n}\n.clearfix::after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n@media (max-width: 1100px) {\n  .row {\n    flex-direction: column;\n  }\n  .hero-section .col-7 {\n    width: 100% !important;\n  }\n}\n","$headingFont :45px;\n$textFont : 22px;\n$textFontSecondary : 10px;\n$buttonFonts : 14px;","$primary-color: #EE3A24;\n$secondary-color: #923D32;\n\n$text_black : #000000;\n$color_white : #fff;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
